const StackdriverErrorReporter = require("stackdriver-errors-js/dist/stackdriver-errors-concat.min.js");
const errorHandler = new StackdriverErrorReporter();

export const errorLogging = () => {
  // errorHandler.start({
  //   key: process.env.REACT_APP_FIREBASE_APIKEY,
  //   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // });
  return errorHandler;
};